import { createSelector } from 'reselect';

import { getFilterParamsAdapter, getTimeFilterParams } from '../../api-adapter';
import * as urlQueryString from './../../urlQueryString';
import * as util from './../../util';
import { filterOwnersScope } from './utils';

export const user = (store) => store.user;
const filters = (store) => store.apps.analytics.filters;
const owners = (store) => store.apps.analytics.owners;
const routerLocation = (store) => store.router.location;

export const getUserInfo = createSelector([user],
  (userState) => ({
    user: userState,
    username: userState.username,
  }));

export const getOwners = createSelector([
  owners,
  (store, defaultFilters) => defaultFilters,
], (ownersState, defaultFilters = []) => {
  const ownersList = ownersState.get('owners');
  const ownersFilter = Array.isArray(defaultFilters) ? defaultFilters : [defaultFilters];
  const parsedOwnerFilters = filterOwnersScope(ownersFilter);
  return {
    items: ownersList,
    selectedItems: ownersList.filter(({ name }) => parsedOwnerFilters.includes(name)),
  };
});

export const getFiltersParams = createSelector([filters], (filtersState) => ({
  ...getFilterParamsAdapter(filtersState.get('filters')),
  ...getTimeFilterParams(filtersState.get('selectedDateFilter')),
}));

export const getMetadataParams = createSelector([
  filters,
  (store, options = {}) => options,
], (filtersState, { value, filterKey }) => ({
  params: {
    ...getFilterParamsAdapter(filtersState.get('filters')),
    ...getTimeFilterParams(filtersState.get('selectedDateFilter')),
    query: value,
    field: filterKey,
  },
}));

export const getInitialFilters = createSelector([
  routerLocation,
  (store, options) => options,
], (location, { defaultFilters } = {}) => {
  const urlQueryParams = urlQueryString.getAll(location);
  const storedFilters = util.getValidLocalFilters(location.pathname);
  const isURLQueryParamExists = urlQueryParams && Object.keys(urlQueryParams).length;
  const initialFilters = util.getFiltersFromQueryParams(
    isURLQueryParamExists ? urlQueryParams : storedFilters, defaultFilters,
  );
  return {
    initialFilters,
    shouldUpdateURL: !isURLQueryParamExists && !!Object.keys(storedFilters).length,
  };
});
